// Constantes dos tipos de quarto
export const ROOM_TYPES = {
  STANDARD: 'STANDARD',
  DELUXE: 'DELUXE', 
  SUITE: 'SUITE',
  PRESIDENTIAL: 'PRESIDENTIAL'
};

// Mapeamento para exibição
export const ROOM_TYPE_LABELS = {
  [ROOM_TYPES.STANDARD]: 'Standard',
  [ROOM_TYPES.DELUXE]: 'Deluxe',
  [ROOM_TYPES.SUITE]: 'Suíte',
  [ROOM_TYPES.PRESIDENTIAL]: 'Presidencial'
};

// Array para selects/dropdowns
export const ROOM_TYPE_OPTIONS = [
  { value: ROOM_TYPES.STANDARD, label: ROOM_TYPE_LABELS[ROOM_TYPES.STANDARD] },
  { value: ROOM_TYPES.DELUXE, label: ROOM_TYPE_LABELS[ROOM_TYPES.DELUXE] },
  { value: ROOM_TYPES.SUITE, label: ROOM_TYPE_LABELS[ROOM_TYPES.SUITE] },
  { value: ROOM_TYPES.PRESIDENTIAL, label: ROOM_TYPE_LABELS[ROOM_TYPES.PRESIDENTIAL] }
];

// Função para traduzir tipos
export const translateRoomType = (type) => {
  // Se o type já é um objeto com label, retornar o label
  if (typeof type === 'object' && type !== null) {
    return type.label || type.name || 'N/A';
  }
  // Se é uma string, buscar no mapeamento
  return ROOM_TYPE_LABELS[type] || type;
};
